import React from "react";
import { motion } from "framer-motion";
import { useI18n } from "@/i18n/I18nProvider";

export default function Manifesto() {
  const { t } = useI18n();
  return (
    <section className="relative bg-white py-20 md:py-32 border-t border-slate-100">
      <div className="max-w-[1440px] mx-auto px-5 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 mb-14 md:mb-20">
          <div className="md:col-span-4">
            <div className="label-eyebrow mb-4">{t.why.eyebrow}</div>
          </div>
          <div className="md:col-span-8">
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.9, ease: [0.2, 0.7, 0.2, 1] }}
              className="font-display font-medium text-slate-900 text-3xl sm:text-4xl md:text-5xl lg:text-6xl leading-[1.03] tracking-tight"
            >
              {t.why.title}
            </motion.h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 border-t border-slate-200">
          {t.why.chapters.map((c, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.06 }}
              className="p-6 md:p-10 border-b border-slate-200 md:border-r [&:nth-child(3n)]:md:border-r-0 hover:bg-slate-50 transition-colors group"
            >
              <div className="flex items-baseline gap-5">
                <div className="font-display font-semibold text-slate-200 text-5xl md:text-6xl leading-none">
                  {String(i + 1).padStart(2, "0")}
                </div>
                <div className="flex-1 pt-3">
                  <h3 className="font-display text-slate-900 text-xl md:text-2xl leading-tight tracking-tight mb-2">{c.t}</h3>
                  <p className="text-slate-600 text-[14.5px] leading-relaxed">{c.d}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
